import * as React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { hasFeature } from 'features/hocs'
import { State } from 'store'
import { RulesList } from 'inventory/rulesList'
import { CapacityRule } from 'capacity/types'
import { capacityPaths } from 'capacity/paths'
import { useTranslation } from 'translations'

interface LimitExceptionsSectionProps {
    accountSlug: string
    capacityId: string
    rules: CapacityRule[]
}

export function LimitExceptionsSection({ accountSlug, capacityId, rules }: LimitExceptionsSectionProps) {
    const { t } = useTranslation()
    const features = useSelector((state: State) => state.features)
    const conviousAdmin = useSelector((state: State) => state.auth.user?.isAdmin ?? false)
    const featureCheck = (featureName: string, slug: string) =>
        hasFeature({ accountSlug: slug, features, featureName, conviousAdmin })

    return (
        <section className="capacity-card capacity-exceptions" aria-labelledby="capacity-exceptions-heading">
            <div className="capacity-card-heading capacity-card-heading-ruled">
                <h2 id="capacity-exceptions-heading" className="capacity-card-title">
                    {t('capacity.exceptions.heading')}
                </h2>
            </div>
            {rules.length > 0 ? (
                <RulesList
                    accountSlug={accountSlug}
                    rulesList={rules}
                    inventoryId={capacityId}
                    hasFeature={featureCheck}
                />
            ) : (
                <p className="capacity-table-note">{t('capacity.exceptions.none')}</p>
            )}
            <Link
                to={capacityPaths.newException(accountSlug, capacityId)}
                className="capacity-text-link capacity-exceptions-add"
                id="newRule"
            >
                {t('capacity.exceptions.add')}
            </Link>
        </section>
    )
}
